"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Page_1 = require("../../Page");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var InsuredPersonTree_1 = require("../InsuredPersonTree");
var InsuredVehicleTree_1 = require("../InsuredVehicleTree");
var Tree_1 = require("../../../components/Tree");
var RenewalInviteMotorInvolvedObjectsTree = /** @class */ (function (_super) {
    __extends(RenewalInviteMotorInvolvedObjectsTree, _super);
    function RenewalInviteMotorInvolvedObjectsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.getVehicleDrivers = function () {
            var allDrivers = [];
            if (_this.props.interaction) {
                allDrivers.push(_this.props.interaction.policyHolder);
                allDrivers.push.apply(allDrivers, _this.props.interaction.additionalDrivers);
            }
            var registeredKeeperId = _this.props.interaction.vehicles[0].registeredKeeperId;
            var mainDriverId = _this.props.interaction.vehicles[0].mainDriverId;
            for (var _i = 0, allDrivers_1 = allDrivers; _i < allDrivers_1.length; _i++) {
                var driver = allDrivers_1[_i];
                if (driver.personId === registeredKeeperId) {
                    driver.objectRole = "registeredKeeper";
                }
                else if (driver.personId === mainDriverId) {
                    driver.objectRole = "mainDriver";
                }
                else {
                    driver.objectRole = "additionalDriver";
                }
            }
            return allDrivers;
        };
        _this.renderVehicles = function () {
            var insuredVehicles = [];
            var _loop_1 = function (vehicle) {
                var interactionVehicle = null;
                var overnightPostcode = "";
                var basicDetails = [
                    vehicle.registrationNumber,
                    vehicle.make,
                    vehicle.model,
                    vehicle.year.toString()
                ];
                interactionVehicle = _this.props.interaction.vehicles.filter(function (car) {
                    return car.registrationNumber === vehicle.registrationNumber;
                })[0];
                overnightPostcode = interactionVehicle.overnightLocationIsHome && _this.props.interaction.policyHolder && _this.props.interaction.policyHolder.address ?
                    _this.props.interaction.policyHolder.address.postcode :
                    interactionVehicle.overnightLocationPostcode;
                var detailString = basicDetails.join(", ");
                insuredVehicles.push((0, jsx_runtime_1.jsx)(InsuredVehicleTree_1.default, { vehicle: vehicle, interactionVehicle: interactionVehicle, drivers: _this.getVehicleDrivers(), treeContentString: detailString, overnightPostcode: overnightPostcode }, vehicle.internalId));
            };
            for (var _i = 0, _a = _this.props.interaction.vehicles; _i < _a.length; _i++) {
                var vehicle = _a[_i];
                _loop_1(vehicle);
            }
            return insuredVehicles;
        };
        _this.state = {};
        return _this;
    }
    RenewalInviteMotorInvolvedObjectsTree.prototype.render = function () {
        if (this.props.interaction) {
            return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "Involved objects", children: [this.renderDrivers(), this.renderVehicles()] }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    RenewalInviteMotorInvolvedObjectsTree.prototype.renderDrivers = function () {
        var _this = this;
        var driverTree = [];
        this.getVehicleDrivers().forEach(function (driver) {
            var personTitle = "";
            var personAddress = "";
            var interactionPerson;
            interactionPerson = driver;
            if (interactionPerson.title) {
                personTitle = interactionPerson.title.charAt(0) + interactionPerson.title.substring(1).toLowerCase() + " ";
            }
            if (interactionPerson.address) {
                personAddress = interactionPerson === null || interactionPerson === void 0 ? void 0 : interactionPerson.address.fullAddress;
            }
            var contentString = personTitle + driver.firstName + " " + driver.lastName + " " + _this.supportPortalTemplates.convertDate(driver.dateOfBirth, "DD/MM/YYYY");
            driverTree.push((0, jsx_runtime_1.jsx)(InsuredPersonTree_1.default, { person: driver, treeContentString: contentString, interactionPerson: interactionPerson, interaction: _this.props.interaction, address: personAddress }, interactionPerson.personId));
        });
        return driverTree;
    };
    RenewalInviteMotorInvolvedObjectsTree.contextType = Page_1.PageContext;
    RenewalInviteMotorInvolvedObjectsTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], RenewalInviteMotorInvolvedObjectsTree);
    return RenewalInviteMotorInvolvedObjectsTree;
}(React.Component));
exports.default = RenewalInviteMotorInvolvedObjectsTree;
//# sourceMappingURL=RenewalInviteMotorInvolvedObjectsTree.js.map